import { addToRouter, getCurrentCid, removeFromRouter } from './router/router'
import { modalQueue } from './queue'
import { closeAllModalPromise } from './event-listener'
import { closeModalComponent } from '../modalViewer/modalViewer'
import { EXIT_TRANSITION_DURATION } from '../setup/config'

export const closeCurrentModal = () => {
  closeModalComponent?.()
  const { closeImmediately } = modalQueue.head() || {}

  return closeImmediately
    ? removeFromRouter()
    : new Promise(resolve => {
        setTimeout(() => {
          removeFromRouter()
          resolve(null)
        }, EXIT_TRANSITION_DURATION)
      })
}

export const addModal = async ({
  id,
  props = {},
  preventBackClick = false,
  closeImmediately = false,
  closeListener,
}: {
  id: string
  props?: unknown
  preventBackClick?: boolean
  closeImmediately?: boolean
  closeListener?: () => unknown
}) => {
  const isQueueEmpty = modalQueue.isEmpty()
  modalQueue.enqueue({
    id,
    props,
    preventBackClick,
    closeImmediately,
    closeListener,
  })

  if (!getCurrentCid() && isQueueEmpty)
    addToRouter({ cid: id, closeImmediately, preventBackClick })
}

export const waitForCloseAllModals = async (): Promise<void> => {
  if (!modalQueue.isEmpty()) await closeAllModalPromise()
}
